function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#1b1464",
  stroke: "#fff",
  strokeWidth: "0.3px",
  d: "M14.276-3.948h-2.243V-14.64h2.243zm13.037 0h-2.251l-5.77-6.934v6.934h-2.251V-14.64h2.252l5.786 6.967v-6.967h2.235z",
  transform: "translate(0 .15) translate(-.262 14.64)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d53d53",
  d: "M3.842-7.5v2.555H1.59V-15.64h4.95a5.02 5.02 0 0 1 3.448 1.13 3.788 3.788 0 0 1 1.279 2.984 3.674 3.674 0 0 1-1.25 2.963 5.255 5.255 0 0 1-3.5 1.06zm0-1.8h2.7a2.662 2.662 0 0 0 1.834-.567 2.08 2.08 0 0 0 .633-1.635 2.236 2.236 0 0 0-.642-1.672 2.459 2.459 0 0 0-1.759-.646H3.842z",
  transform: "translate(0 .15) translate(-1.59 15.64)"
}));

var SvgHGamePin = function SvgHGamePin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.201,
    height: 10.992,
    viewBox: "0 0 27.201 10.992",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHGamePin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-gamePin.d9ba1b0a.svg";
export { ForwardRef as ReactComponent };